import {
	addClass,
	removeClass,
	hasClass,
	setAttribute,
	getAttribute,
	query,
} from "../utils";

const createTransitionClasses = (elementName, baseClass) => ({
	[`${elementName}IsOpen`]: `${baseClass}--open`,
	[`${elementName}IsClosing`]: `${baseClass}--closing`,
	[`${elementName}IsClosed`]: `${baseClass}--closed`,
});

class MobileMenu {
	#button = null;
	get button() {
		return this.#button;
	}

	set button(_button) {
		this.#button = _button;
	}

	#menu = null;
	get menu() {
		return this.#menu;
	}

	set menu(_menu) {
		this.#menu = _menu;
	}

	#mql = null;
	get mql() {
		return this.#mql;
	}

	set mql(_mql) {
		this.#mql = _mql;
	}

	buttonClasses = {};
	menuClasses = {};
	constructor() {
		document.addEventListener("DOMContentLoaded", this.initializeMenu);
	}

	initializeMenu = () => {
		this.buttonClasses = createTransitionClasses(
			"button",
			"block-site-wide-header__mobile-button"
		);
		this.menuClasses = createTransitionClasses(
			"menu",
			"block-site-wide-header__navigation-container"
		);

		if (!this.button) {
			this.button = document.getElementById("mobile-button");
			this.button.addEventListener("click", this.handleMenuClick);
		}
		if (!this.menu) {
			this.menu = document.getElementById("main-nav");
			this.menu.addEventListener("transitionend", this.handleMenuTransition);
		}
		if (!this.mql) {
			this.mql = window.matchMedia("only screen and (min-width: 87.5em)");
			this.mql.addEventListener("change", this.handleMqlChange);
		}
	};

	handleMqlChange = (event) => {
		if (
			event.matches &&
			getAttribute(this.button, "aria-expanded") === "true"
		) {
			this.resetMenu();
		}
	};

	resetMenu = () => {
		const body = query("body");
		setAttribute(this.button, { "aria-expanded": false });
		removeClass(this.button, this.buttonClasses.buttonIsOpen);
		addClass(this.button, this.buttonClasses.buttonIsClosed);

		removeClass(this.menu, this.menuClasses.menuIsClosing);
		removeClass(this.menu, this.menuClasses.menuIsOpen);
		addClass(this.menu, this.menuClasses.menuIsClosed);
		removeClass(body, "no-scroll");

		// Hide custom link when menu is reset
		const customLink = document.querySelector('.custom-link');
		if (customLink) {
			customLink.style.display = 'none';
		}
	};

	handleMenuTransition = () => {
		if (hasClass(this.menu, this.menuClasses.menuIsClosing)) {
			const body = query("body");
			removeClass(this.menu, this.menuClasses.menuIsClosing);
			addClass(this.menu, this.menuClasses.menuIsClosed);

			removeClass(body, "no-scroll");
		}
	};

	handleOpenMenu = () => {
		const body = query("body");
		setAttribute(this.button, { "aria-expanded": true });
		removeClass(this.button, this.buttonClasses.buttonIsClosed);
		addClass(this.button, this.buttonClasses.buttonIsOpen);

		addClass(this.menu, this.menuClasses.menuIsOpen);
		addClass(body, "no-scroll");

		// Show custom link when menu is opened
		const customLink = document.querySelector('.custom-link');
		if (customLink) {
			customLink.style.display = 'block';
		}
	};

	handleCloseMenu = () => {
		setAttribute(this.button, { "aria-expanded": false });
		removeClass(this.button, this.buttonClasses.buttonIsOpen);
		addClass(this.button, this.buttonClasses.buttonIsClosed);

		removeClass(this.menu, this.menuClasses.menuIsOpen);
		addClass(this.menu, this.menuClasses.menuIsClosing);

		// Hide custom link when menu is closed
		const customLink = document.querySelector('.custom-link');
		if (customLink) {
			customLink.style.display = 'none';
		}
	};

	handleMenuClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (getAttribute(this.button, "aria-expanded") === "false") {
			this.handleOpenMenu();
		} else {
			this.handleCloseMenu();
		}
	};
}

export { MobileMenu };
